import { ArrowRoundComponent } from "assets/icons";
import React from "react";
import { useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import "./styles.scss";
import useTranslation from "hooks/useTranslation";
import * as animationData from "assets/gifs/chat-bot.json";
import Lottie from "lottie-react";
import { WebPageIconComponent } from "assets/icons";

const getUserChannels = ({ userData }) => userData.userChannels;

const UserChannels = ({ setConvBodyContent }) => {
  const userChannels = useSelector(getUserChannels);
  const { data, loading } = userChannels;

  const { getTranslation } = useTranslation("HOME");
  const { t } = getTranslation();

  const renderLoader = (
    <div className="flex w-100 flex-jc-c">
      <ThreeDots
        height="80"
        width="80"
        radius="9"
        color="#b10e84"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClassName=""
        visible={true}
      />
    </div>
  );

  const channelsTitle = (
    <h2 className="channels__title">
      {loading
        ? ""
        : !data?.length
        ? t("NO_WEBSITES_ADDED_TITLE")
        : t("WEBSITES_LIST_TITLE")}
    </h2>
  );

  const userChannelsMain = (
    <>
      {!!loading ? (
        renderLoader
      ) : !data?.length ? (
        <div className="flex flex-ai-c">
          <button className="btn btn-primary add_new_website_btn">
            {t("ADD_NEW_WEBSITE")}
          </button>
        </div>
      ) : (
        <div className="channels__list">
          {data?.map((channel, index) => (
            <a
              target="blank"
              className="channel__url"
              href={channel.url}
              key={index} // the order of items will not change, then index used as key
            >
              <WebPageIconComponent className="web_page_icon" />

              <div className="flex flex-ai-c flex-columngap-16">
                <span className="channel__url_text">{channel.url}</span>

                <ArrowRoundComponent className="arrow_round" />
              </div>
            </a>
          ))}
        </div>
      )}
    </>
  );

  return (
    <div className="channels__main__container">
      <div className="robot_animation">
        <Lottie animationData={animationData} loop={false} />
      </div>

      <h1 className="welcome_title"> {t("WELCOME")}</h1>

      <div className="flex flex-jc-sb flex-ai-c sub-title-text">
        {channelsTitle}
      </div>

      {userChannelsMain}
    </div>
  );
};

export default UserChannels;
